import React, { Component, useEffect, useState } from "react";
import { Fragment } from "react";
import config from "../../component/config";
import crypto from "crypto-js";
import { currencyFormat } from "../../component/component";
import PaymentDetails from "../component/payment-details";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { InputLabel } from "../../component/form-control";

const formatDate = (date) => moment(new Date(date)).format("MMM-DD-YYYY");

const BillingLabel = ({ label, text, _class }) => (
  <div className={`form-group ${_class}`}>
    <label className="small">{label}</label>
    <label className="form-control border-0">
      <strong>{text}</strong>
    </label>
  </div>
);

const Miscellaneous = (props) => {
  const [data, setData] = useState({});
  const navigate = useNavigate();

  const goBack = () => navigate("/payment");

  useEffect(() => {
    const data = sessionStorage.getItem("data");
    if (data) {
      const billing = crypto.AES.decrypt(data, config.secretKey).toString(
        crypto.enc.Utf8
      );

      setData(JSON.parse(billing));
    } else {
      navigate("/home");
    }
  }, []);

  const { vwBillingDetails } = data;

  return (
    <>
      <div className="max-w-5xl border rounded-lg mx-auto p-5 mb-20">
        <div className="text-orange-500 mb-2 border-b pb-2 font-bold">
          Billing Summary
        </div>
        <div className="grid grid-cols-3 gap-y-1.5 mb-5">
          <InputLabel label="Tax Payer's Name" value={data.name} />
          <InputLabel label="Type" value={"Miscellaneous"} />
          <InputLabel label="Billing Number" value={data.bill_no} />
          <InputLabel label="Billing Date" value={data.bill_date} />
          <InputLabel label="Validity" value={data.validity} />
          <InputLabel
            label="Total Amount"
            value={currencyFormat(data.total_amount)}
          />
          <InputLabel label="Remarks" value={data.remarks} />
        </div>

        <div className="text-orange-500 mb-2 border-b pb-2 font-bold">
          Billing Details
        </div>
        <table className="w-full text-sm border">
          {/* <colgroup>
            <col />
            <col />
            <col width="150" />
            <col width="150" />
            <col width="150" />
          </colgroup> */}

          <thead className="bg-green-700 text-white text-center">
            <tr>
              <td className="p-2 border">Code</td>
              <td className="p-2 border">Description</td>
              <td className="p-2 border">Amount</td>
              <td className="p-2 border">Qty</td>
              <td className="p-2 border">Total</td>
            </tr>
          </thead>
          <tbody>
            {vwBillingDetails &&
              vwBillingDetails.map((row, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 1 && "bg-gray-100"
                  } hover:bg-gray-300`}
                >
                  <td className="p-2 border">{row.code}</td>
                  <td className="p-2 border">{row.description}</td>
                  <td className="text-right p-2 border">
                    {currencyFormat(row.amount)}
                  </td>
                  <td className="text-center p-2 border">{row.qty}</td>
                  <td className="text-right p-2 border">
                    {currencyFormat(row.total)}
                  </td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr className="">
              <td colSpan="4" className="text-right p-5">
                Grand Total
              </td>
              <td className="text-right p-2 font-bold text-orange-700">
                {currencyFormat(data.total_amount)}
              </td>
            </tr>
          </tfoot>
        </table>

        <div className="px-5 border bg-gray-50">
          <PaymentDetails type="misc" />
        </div>

        <button
          type="button"
          className="flex bg-red-700 border text-white rounded mx-auto m-2"
          onClick={goBack}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
            />
          </svg>{" "}
          Back
        </button>
      </div>
    </>
  );
};

export default Miscellaneous;
